// SidebarMenu.jsx
import React from 'react';
import { View, Text, TouchableOpacity, Image } from 'react-native';
import styles from '../styles/homeWebStyles';

const iconMap = {
    home: {
        active: require('../../assets/icons/home_laranja.png'),
        inactive: require('../../assets/icons/home_cinza.png'),
    },
    perfil: {
        active: require('../../assets/icons/perfil_laranja.png'),
        inactive: require('../../assets/icons/perfil_cinza.png'),
    },
    whatsapp: {
        active: require('../../assets/icons/whatsapp.png'),
        inactive: require('../../assets/icons/whatsapp_cinza.png'),
    },
    sair: {
        active: require('../../assets/icons/sair_laranja.png'),
        inactive: require('../../assets/icons/sair_cinza.png'),
    },
};

const sidebarItems = [
    { icon: 'home', label: 'Home', route: 'HomeWeb' },
    { icon: 'perfil', label: 'Perfil', route: 'PerfilWeb' },
    { icon: 'whatsapp', label: 'WhatsApp', route: 'https://wa.me/message/DUKGPWRP7JPDF1', isExternal: true },
    { icon: 'sair', label: 'Sair', route: '/logout', isLogout: true },
];

export default function SidebarMenu({ currentPath, onNavigate, onLogout }) {
    return (
        <View style={styles.menuList}>
            {sidebarItems.map((item, idx) => {
                const isActive = currentPath === item.route;
                const iconSource = isActive
                    ? iconMap[item.icon].active
                    : iconMap[item.icon].inactive;

                return (
                    <TouchableOpacity
                        key={idx}
                        style={styles.menuItem}
                        onPress={
                            item.isLogout
                                ? onLogout
                                : item.isExternal
                                    ? () => window.open(item.route, '_blank')
                                    : () => onNavigate(item.route)
                        }
                    >
                        <Image source={iconSource} style={styles.menuIcon} />
                        <Text style={[styles.menuLabel, isActive && { color: '#FB7D10', fontWeight: 'bold' }]}>
                            {item.label}
                        </Text>
                    </TouchableOpacity>
                );
            })}
        </View>
    );
}
